import React from 'react';

interface ChevronUpIconProps {
    className?: string;
}

const ChevronUpIcon: React.FC<ChevronUpIconProps> = ({ className = "w-2 h-1" }) => (
    <svg className={className} fill="currentColor" viewBox="0 0 10 6">
        <path d="M8.8 5.2a.8.8 0 0 1-1.13 0L5 2.53 2.33 5.2a.8.8 0 1 1-1.13-1.13l3.2-3.2a.8.8 0 0 1 1.13 0l3.2 3.2a.8.8 0 0 1 .07 1.13Z" fill="currentColor"/>
    </svg>
);

export default ChevronUpIcon;

